import { SearchInput } from '@billy/design-system'
import { ChangeEvent, ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useImportedInvoicesListFilters } from '../../../../context/importedInvoicesListFilters'

export const ImportedInvoicesSearch = (): ReactElement => {
  const { t } = useTranslation()
  const [{ searchQuery }, setFilters] = useImportedInvoicesListFilters()

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setFilters({ page: 1, searchQuery: event.target.value || undefined })
    },
    [setFilters],
  )

  const handleClear = useCallback(() => {
    setFilters({ page: 1, searchQuery: undefined })
  }, [setFilters])

  return (
    <SearchInput
      focused={!!searchQuery}
      onChangeDebounced={handleChange}
      onClear={handleClear}
      placeholder={t('imported_invoices.list.search.placeholder')}
      value={searchQuery}
    />
  )
}
